import { motion } from "framer-motion";
import { useInView } from "framer-motion";
import { useRef } from "react";

const stats = [
  { number: "1 in 4", label: "feel socially isolated" },
  { number: "44%", label: "experience daily stress" },
  { number: "$2.5T", label: "global economic loss" },
];

const StatsSection = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });

  return (
    <section
      data-testid="stats-section"
      ref={ref}
      className="relative z-10 py-24 lg:py-32"
    >
      <div className="max-w-6xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
          {stats.map((stat, i) => (
            <motion.div
              key={stat.label}
              initial={{ opacity: 0, y: 30 }}
              animate={isInView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.7, delay: i * 0.2 }}
              data-testid={`stat-card-${i}`}
              className="glass-card rounded-2xl p-8 lg:p-10 text-center"
            >
              <div className="stat-number text-4xl sm:text-5xl lg:text-6xl font-black tracking-tight">
                {stat.number}
              </div>
              <p className="mt-4 text-sm lg:text-base text-zinc-400 font-medium tracking-wide uppercase">
                {stat.label}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StatsSection;
